<script>
import AppTable from "../form-generator/AppTable.vue";
import axios from "axios";
import {VueFinalModal} from "vue-final-modal";

import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-json";

export default {
  name: "api-log-external",
  components: {AppTable, VueFinalModal},
  data() {
    return ({
      fields: [
        {label: "Kdy", type: "dateTime", display_filter: 'dateTime', codename: "created_at"},
        {label: "Endpoint", type: "text", codename: "endpoint"},
        {label: "Metoda", type: "text", codename: "request_method"},
        {label: "Status", type: "text", codename: "status"},
        {label: "Token", type: "text", codename: "token_name"},
        {label: "Eshop", type: "text", codename: "eshop"},
        {label: "external_id", type: "text", codename: "external_id"},
        {label: "Student", type: "text", codename: "student_email"},
        {label: "ms", type: "text", codename: "duration_ms"},
        {label: "Chyba", type: "text", codename: "error"}
      ],
      filters: [
        {label: "Kdy", type: "date-range", codename: "created_at"},
        {
          label: "Výsledek", type: "select", codename: "result",
          options: [
            {value: '', label: 'Vše'},
            {value: 'errors', label: 'Jen chyby (4xx/5xx)'},
            {value: 'ok', label: 'Jen úspěšné'},
            {value: 'writes', label: 'Jen zápisy'}
          ]
        },
        {
          label: "Endpoint", type: "select", codename: "endpoint",
          options: [
            {value: '', label: 'Vše'},
            {value: 'orders#create', label: 'POST /orders'},
            {value: 'orders#paid', label: 'POST /orders/:id/paid'},
            {value: 'orders#show', label: 'GET /orders/:id'},
            {value: 'orders#index', label: 'GET /orders'},
            {value: 'catalog#products', label: 'GET /catalog/products'},
            {value: 'catalog#eshops', label: 'GET /catalog/eshops'},
            {value: 'catalog#campaigns', label: 'GET /catalog/campaigns'},
            {value: 'students#index', label: 'GET /students'},
            {value: 'students#show', label: 'GET /students/:id'}
          ]
        },
        {type: 'search'}
      ],
      app: {
        data_url: '/api_log/external.json',
        actions: ""
      },

      showModal: false,
      item: {},
      requestCode: '',
      responseCode: ''
    })
  },
  methods: {
    handleItemClick(item) {
      axios.get('/api_log/external/' + item.id + '.json').then((response) => {
        this.item = response.data
        this.requestCode = this.pretty(this.item.request_body)
        this.responseCode = this.pretty(this.item.response_body)
        this.showModal = true
      })
    },
    pretty(raw) {
      if (!raw) return ''
      try {
        return JSON.stringify(JSON.parse(raw), null, 2)
      } catch (e) {
        return raw
      }
    },
    highlight(code) {
      if (!code) return ''
      return Prism.highlight(code, Prism.languages.json, 'json')
    },
    statusClass(status) {
      if (status >= 500) return 'badge badge-danger'
      if (status >= 400) return 'badge badge-warning'
      return 'badge badge-success'
    },
    copy(code) {
      navigator.clipboard.writeText(code)
    }
  }
}
</script>

<template>
  <div>
    <h1>Log externího API</h1>
    <p class="text-muted">
      Každý request na <code>/api/external/*</code> včetně neúspěšných pokusů o autentizaci.
      Klikni na řádek pro celý JSON requestu i odpovědi.
    </p>

    <div class="card card-body index p-0">
      <AppTable :app="app" :fields="fields" :filters="filters" @itemClick="handleItemClick"></AppTable>
    </div>

    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content-f mcw1">
      <div class="modal-header">
        <span class="modal__title fg-modal-title">
          {{ item.request_method }} {{ item.path }}
          <span :class="statusClass(item.status)">{{ item.status }}</span>
        </span>
        <button type="button" class="close" @click.prevent="showModal=false" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal__content">
        <table class="table table-sm meta">
          <tbody>
          <tr><th>Kdy</th><td>{{ item.created_at }}</td><th>Trvání</th><td>{{ item.duration_ms }} ms</td></tr>
          <tr><th>Token</th><td>{{ item.token_name || '—' }}</td><th>IP</th><td>{{ item.ip }}</td></tr>
          <tr><th>Eshop</th><td>{{ item.eshop || '—' }}</td><th>external_id</th><td>{{ item.external_id || '—' }}</td></tr>
          <tr><th>Student</th><td>{{ item.student_email || '—' }}</td><th>Objednávka</th><td>{{ item.order_id || '—' }}</td></tr>
          <tr v-if="item.user_agent"><th>User agent</th><td colspan="3">{{ item.user_agent }}</td></tr>
          <tr v-if="item.error"><th>Chyba</th><td colspan="3" class="text-danger">{{ item.error }}</td></tr>
          </tbody>
        </table>

        <div v-if="requestCode">
          <h5>
            Request
            <button class="btn btn-sm btn-outline-secondary" @click="copy(requestCode)">kopírovat</button>
          </h5>
          <pre v-html="highlight(requestCode)" class="tmave"></pre>
        </div>

        <h5>
          Odpověď
          <button class="btn btn-sm btn-outline-secondary" @click="copy(responseCode)">kopírovat</button>
        </h5>
        <pre v-html="highlight(responseCode)" class="tmave"></pre>
      </div>
    </vue-final-modal>
  </div>
</template>

<style scoped>
.tmave {
  background: #2E2F30;
  padding: 10px;
  max-height: 420px;
  overflow: auto;
}

.meta th {
  width: 110px;
  white-space: nowrap;
}
</style>
